import { useEffect, useState } from 'react';
import fr from 'facet-rest';
import { useSnackbarContext } from 'Context/SnackbarContext';

async function fetchManagedAccountPerformanceDashboardData(_res) {
  let portfolio;
  let benchmarkedPerformance;
  let highlightedCommentary;
  let historicalCommentaries;

  if (!_res?.link('self')) return {};

  const [resource] = await _res.link('self').get();

  // fetch portfolio
  const portfolioCollection = await resource.relationship(fr.relationships.portfolio.name)?.link('related').get();
  if (portfolioCollection) {
    [portfolio] = portfolioCollection;
  }

  // fetch benchmarked performance;
  const benchmarkedPerformanceCollection = await resource.relationship(fr.relationships.benchmarkedPerformance.name)?.link('related').get();
  if (benchmarkedPerformanceCollection) {
    [benchmarkedPerformance] = benchmarkedPerformanceCollection;
  }

  // fetch highlighted commentary;
  const highlightedCommentaryCollection = await resource.relationship(fr.relationships.highlightedCommentary.name)?.link('related').get();
  if (highlightedCommentaryCollection) {
    [highlightedCommentary] = highlightedCommentaryCollection;
  }

  // fetch historical commentaries;
  const historicalCommentariesCollection = await resource.relationship(fr.relationships.historicalCommentaries.name)?.link('related').get();
  if (historicalCommentariesCollection) {
    historicalCommentaries = historicalCommentariesCollection;
  }

  return {
    resource,
    portfolio,
    benchmarkedPerformance,
    highlightedCommentary,
    historicalCommentaries,
  };
}

export default function useManagedAccountPerformanceDashboard(_res) {
  const { displayErrorMessage } = useSnackbarContext();

  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(null);
  const [performanceDashboard, setPerformanceDashboard] = useState(null);
  const [portfolio, setPortfolio] = useState(null);
  const [benchmarkedPerformance, setBenchmarkedPerformance] = useState(null);
  const [highlightedCommentary, setHighlightedCommentary] = useState(null);
  const [historicalCommentaries, setHistoricalCommentaries] = useState(null);

  useEffect(() => {
    let ignore = false;

    (async function fetchData() {
      setIsLoading(true);
      setIsError(null);

      try {
        const data = await fetchManagedAccountPerformanceDashboardData(_res);
        if (!ignore) {
          setPerformanceDashboard(data.resource);
          setPortfolio(data.portfolio);
          setBenchmarkedPerformance(data.benchmarkedPerformance);
          setHighlightedCommentary(data.highlightedCommentary);
          setHistoricalCommentaries(data.historicalCommentaries);
        }
      } catch (e) {
        setIsError(e || true);
        displayErrorMessage(e, (e.errors && e.errors[0]?.detail) || 'There was a problem loading this page.');
      }

      setIsLoading(false);
    }());

    return () => {
      ignore = true;
    };
  }, [_res]);

  return {
    isLoading,
    isError,
    performanceDashboard,
    portfolio,
    benchmarkedPerformance,
    highlightedCommentary,
    historicalCommentaries,
    setBenchmarkedPerformance,
  };
}
